import 'select2';
import $ from 'jquery';
import { initRichTextForEmail } from './email.js'

window.jQuery = $;
window.$ = $;

function select2() {
  console.log('inside select2 function');
  const program_cycle_menus = document.querySelectorAll("#report_program_cycle_ids");
  $(program_cycle_menus).select2();
};

$(function () {
  const multi_menus = document.querySelectorAll("select[multiple]");
  const single_menus = document.querySelectorAll("select.select2");
  const program_cycle_menus = document.querySelectorAll("#report_program_cycle_ids");

  $(program_cycle_menus).select2({
    closeOnSelect: false
  });
  $(single_menus).select2();
  $(multi_menus).select2({
    closeOnSelect: false
  });
});

$(function () {
  const multi_menus = document.querySelectorAll("select[multiple]");
  const single_menus = document.querySelectorAll("select.select2");
  const program_cycle_menus = document.querySelectorAll("#report_program_cycle_ids");

  $(program_cycle_menus).select2({
    closeOnSelect: false
  });
  $(single_menus).select2();
  $(multi_menus).select2({
    closeOnSelect: false
  });
});

$(document).on('ajax:success', 'form[data-bulk-enroll]', function () {
  console.log('inside ajax:success!!');

  $('.select2').select2({
    closeOnSelect: false
  });

})

$(function() {
  initRichTextForEmail();
})

$(document).on('ajax:success', 'form[data-reports-form]', function () {
  console.log('inside ajax:success');

  $('.select2').select2({
    dropdownParent: $('#reportModal'),
    closeOnSelect: false
  });
});

$(document).on('ajax:success', 'form[data-reports-form]', function () {
  console.log('inside ajax:success');

  $('.select2').select2({
    dropdownParent: $('#reportModal'),
    closeOnSelect: false
  });
});

$(document).on('ajax:send', 'form[data-reports-form]', function () {
  var target = $(this);
  target.hide();
  target.on('ajax:success', function (evt) {
    var status = evt.detail[2].status;
    if (status === 200) {
      $('#reportModal').find('.modal-body').html(evt.detail[0].form)
    } else {
      alert('Whoops! Something went wrong. Sorry about that.');
      el = $.parseHTML(data.responseText)[0]
      search_target.replaceWith(el);
    }
  })
});

$(document).on("click", ".report-button", function () {
  var report_type = $(this).data('id');
  $(".modal-body #report_type").val(report_type);
  $(".modal-body #report_type").val(report_type);
});

$(function () {
  $('form').on('focus', 'input[type=number]', function () {
    $(this).on('mousewheel.disableScroll', function (e) {
      e.preventDefault();
    })
  });

  $('form').on('blur', 'input[type=number]', function () {
    $(this).off('mousewheel.disableScroll');
  })
});
